const getTests = state => state.tests

export const getWebsocketClientSelector = state =>
    getTests(state).websocketClient ? getTests(state).websocketClient : null
